import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import SingleCard from "../../layouts/content/SingleCard/SingleCard";
import { getTranslation as translate } from "logic/LocaleManager";

// Externals
import compose from "recompose/compose";

// Component styles
import classes from "./LoggedOutPage.module.scss";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "redux/actions/bosUserActions";
import * as solutionsCacheActions from "redux/actions/solutionsCacheActions";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";
import * as sessionActions from "redux/actions/sessionActions";

const LOGIN_URI = "/login";

function LoggedOutPage(props) {
  const { location } = props;
  const searchParams = (location && location.search);

  console.log("searchParams", searchParams);
  let params = new URLSearchParams(searchParams);
  const logoutReason = params.get("logoutreason");

  useEffect(() => {
    props.bosUserActions.clearBosUser();
    props.solutionsCacheActions.clearSolutionsCache();
    props.dataSegmentActions.clearDataSegment();
    props.sessionActions.clearSessions();
  }, []);

  const isErrorMessage = (logoutReason) => {
    return logoutReason < 0;
  }

  const toLogoutMessage = (logoutReason) => {
    switch (logoutReason) {
      case "1":
        return translate("loggedOut.successfullyLoggedoutMessage", "You have been successfully logged out!");
      case "-1":
        return translate("loggedOut.unauthorizedLoggedoutMessage", "You have been logged out because your session expired!");
      case "-2":
        return translate("loggedOut.loginNotCompletedMessage", "Your login could not be completed!");
      default:
        return translate("loggedOut.loggedoutMessage", "You have been logged out!");
    }
  }

  let isError = isErrorMessage(logoutReason);
  let message = toLogoutMessage(logoutReason);

  const gotoLogin = () => {
    props.history.replace(LOGIN_URI);
  }

  return (
      <SingleCard onBackClicked={gotoLogin} showBackButton={true} >
        <div className={classes.result}>
          <div className={isError ? classes.errorMessage : classes.successMessage}>
            {message}
          </div>
          <div className={classes.result}>
            <Link to={LOGIN_URI}>{translate("loggedOut.gotoLoginLink", " --- GOTO LOGIN --- ")}</Link>
          </div>
        </div>
      </SingleCard>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch),
    solutionsCacheActions: bindActionCreators(solutionsCacheActions, dispatch),
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
    sessionActions: bindActionCreators(sessionActions, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  )
)(LoggedOutPage);

